var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9725 12.5215C22.9725 6.98863 19.9478 3.14848 16.0341 1.99557C15.8924 1.62568 15.6684 1.28181 15.364 0.99327C14.3238 0.00745156 12.7029 0.00745156 11.6627 0.99327C11.359 1.28115 11.1353 1.62412 10.9936 1.99305C7.07472 3.14085 4.05397 6.97265 4.05397 12.5215C4.05397 16.1116 3.3364 18.1233 2.00801 19.5812C1.78591 19.8249 1.18414 20.3833 0.776526 20.7616C0.583688 20.9405 0.434305 21.0791 0.389134 21.125L0 21.523V26.1712H8.22699C8.50518 27.6189 9.28389 28.5874 10.6921 29.4542C12.4244 30.5205 14.6024 30.5205 16.3347 29.4542C17.5775 28.6892 18.4108 27.5135 18.7489 26.1712H27.0265V21.523L26.6374 21.125C26.5964 21.0831 26.4531 20.9498 26.2657 20.7754C25.8594 20.3973 25.2458 19.8264 25.0203 19.5779C23.691 18.1133 22.9725 16.099 22.9725 12.5215ZM15.8603 26.1712H11.0521C11.2431 26.5295 11.5685 26.8 12.0999 27.1271C12.9678 27.6613 14.059 27.6613 14.9269 27.1271C15.3288 26.8797 15.6428 26.5524 15.8603 26.1712ZM23.0267 21.1187C23.311 21.432 23.9205 22.0047 24.3237 22.3788V23.1451H2.70254V22.3794C3.10263 22.0097 3.71392 21.4374 3.99776 21.1259C5.80278 19.1449 6.75651 16.4712 6.75651 12.2214C6.75651 7.06892 9.90884 4.05995 13.5131 4.05995C17.1073 4.05995 20.2698 7.08445 20.2698 12.2214C20.2698 16.4575 21.2238 19.1321 23.0267 21.1187Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellDarkMode);
export default __webpack_public_path__ + "static/media/bell_dark_mode.0a15212c71da86d008629dc96652f5f5.svg";
export { ForwardRef as ReactComponent };